import Styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents';
import { HeaderInnerContainer } from '../HeaderInnerContainer';

const collapsibleSubNavHeight: string = '2.75em;';

export const CollapsibleSubNavInnerContainer = Styled(HeaderInnerContainer)`
  height: ${collapsibleSubNavHeight};

  ${({theme: { header: { collapsibleSubNav }}}) => collapsibleSubNav && css`
      height: ${collapsibleSubNav.height && collapsibleSubNav.height};
  `}
`;

CollapsibleSubNavInnerContainer.displayName = 'CollapsibleSubNavInnerContainer';

export const CollapsibleSubNavInnerContainerWithoutPadding =
  Styled(HeaderInnerContainer)`
    height: ${collapsibleSubNavHeight};
    padding: 0;

    ${({theme: { header: { collapsibleSubNav }}}) => collapsibleSubNav && css`
      height: ${collapsibleSubNav.height && collapsibleSubNav.height};
    `}

    ${media.small`
      padding: 0 1.5em;
    `}

    ${media.medium`
      padding: 0;
    `}

    ${media.xlarge`
      padding: 0;
    `}
  `;

CollapsibleSubNavInnerContainerWithoutPadding.displayName = 'CollapsibleSubNavInnerContainerWithoutPadding';
